// Auto-detect scrollable table containers and toggle CSS classes for scroll indicators
export function initScrollIndicators() {
  const check = (el) => {
    const isScrollable = el.scrollWidth > el.clientWidth + 1;
    const atEnd = el.scrollLeft + el.clientWidth >= el.scrollWidth - 1;
    el.classList.toggle('is-scrollable', isScrollable);
    el.classList.toggle('scrolled-end', isScrollable && atEnd);
  };

  const observe = () => {
    document.querySelectorAll('.table-container').forEach((el) => {
      if (!el.dataset.scrollBound) {
        el.dataset.scrollBound = '1';
        el.addEventListener('scroll', () => check(el), { passive: true });
      }
      check(el);
    });
  };

  // Re-scan on DOM changes (new tables rendered by React)
  const observer = new MutationObserver(observe);
  observer.observe(document.body, { childList: true, subtree: true });
  // Also check on window resize
  window.addEventListener('resize', observe, { passive: true });
  observe();

  return () => {
    observer.disconnect();
    window.removeEventListener('resize', observe);
  };
}
